import { render, staticRenderFns } from "./StepperRider.vue?vue&type=template&id=55b01d3c&scoped=true"
import script from "./StepperRider.vue?vue&type=script&lang=js"
export * from "./StepperRider.vue?vue&type=script&lang=js"
import style0 from "./StepperRider.vue?vue&type=style&index=0&id=55b01d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b01d3c",
  null
  
)

export default component.exports